const images = {
  cassette: require("./assets/cassette.png"),
  cassette_1: require("./assets/cassette_1.png"),
  cassette_2: require("./assets/cassette_2.png"),
  cassette_3: require("./assets/cassette_3.png"),
  cassette_4: require("./assets/cassette_4.png"),
  cassette_5: require("./assets/cassette_5.png"),
  cassette_6: require("./assets/cassette_6.png"),
  cassette_7: require("./assets/cassette_7.png"),
  lookIvery: require("./assets/lookivery_render12_256.png"),
  lookiveryintro: require("./assets/lookiveryintro.png"),
  lookivery2: require("./assets/lookivery2.png"),
  ivery: require("./assets/ivery.png"),
  intro: require("./assets/intro.png"),
  menu_icon: require("./assets/menu_icon.png"),
  ballmaze: require("./assets/ballmaze.png"),
  partiful: require("./assets/partiful_mu.png"),
  partiful_problem: require("./assets/partiful_problem.png"),
  partiful_sketch1: require("./assets/partiful_sketch1.png"),
  partiful_sketch2: require("./assets/partiful_sketch2.png"),
  partiful_wireframe1: require("./assets/partiful_wireframe1.png"),
  partiful_wireframe2: require("./assets/partiful_wireframe2.png"),
  partiful_wireframe3: require("./assets/partiful_wireframe3.png"),
  partiful_wireframe4: require("./assets/partiful_wireframe4.png"),
  partiful_wireframe5: require("./assets/partiful_wireframe5.png"),
  partiful_styleguide: require("./assets/partiful_styleguide.png"),
  partiful_event1: require("./assets/partiful_styleguide.png"),
  partiful_event2: require("./assets/partiful_styleguide.png"),
  partiful_basic_hifi: require("./assets/partiful_basic_hifi.png"),
  partiful_basic_hifi2: require("./assets/partiful_basic_hifi2.png"),
  partiful_basic_hifi3: require("./assets/partiful_basic_hifi3.png"),
  partiful_map_design: require("./assets/partiful_map_design.png"),
  partiful_map_design_past: require("./assets/partiful_map_design_past.png"),
  partiful_notif: require("./assets/partiful_notif.png"),
  partiful_notif_past: require("./assets/partiful_notif_past.png"),
  partiful_notif_expanded_past: require("./assets/partiful_notif_expanded_past.png"),
  panda: require("./assets/panda.png"),
  panda_ui: require("./assets/panda_ui.png"),
  foam: require("./assets/foam_mu.png"),
  foam_compare: require("./assets/foam_compare.png"),
  foam_favourites: require("./assets/foam_favourites.png"),
  foam_landing_expanded: require("./assets/foam_landing_expanded.png"),
  foam_landing: require("./assets/foam_landing.png"),
  foam_figma_favourite: require("./assets/foam_figma_favourite.png"),
  foam_figma_landing_page: require("./assets/foam_figma_landing_page.png"),
  sf: require("./assets/sf_mu.png"),
  sf_problem: require("./assets/sf_problem.png"),
  sf_ipad_mu: require("./assets/sf_ipad_mu.png"),
  sf_ipad: require("./assets/sf_ipad.png"),
  sf_ipadhigh2: require("./assets/sf_ipadhigh2.png"),
  sf_ipadlow: require("./assets/sf_ipadlow.png"),
  sf_iphone_mu: require("./assets/sf_iphone_mu.png"),
  sf_iphone: require("./assets/sf_iphone.png"),
  sf_mac_mu: require("./assets/sf_mac_mu.png"),
  sf_mac: require("./assets/sf_mac.png"),
  sf_machigh2: require("./assets/sf_machigh2.png"),
  sf_maclow: require("./assets/sf_maclow.png"),
  sf_phonehigh2: require("./assets/sf_phonehigh2.png"),
  sf_phonelow: require("./assets/sf_phonelow.png"),
  sf_speedy1: require("./assets/sf_speedy1.png"),
  sf_speedy2: require("./assets/sf_speedy2.png"),
  sf_styleguide: require("./assets/sf_styleguide.png"),
  smiley_balloon: require("./assets/smiley_balloon.png"),
  drivealive: require("./assets/drivealive-mu.png"),
  drivealive_archi: require("./assets/drivealive_archi.png"),
  drivealive_interface: require("./assets/drivealive_interface.png"),
  bayer: require("./assets/bayer.png"),
  bayer_black: require("./assets/bayer_black.png"),
  bayer_process: require("./assets/bayer_process.png"),
  bayer_project: require("./assets/bayer_project.png"),
  bayer_research: require("./assets/bayer_research.png"),
  bayer_storyboard: require("./assets/bayer_storyboard.png"),
  bayer_ux: require("./assets/bayer_ux.png"),
  bayer_uxchart: require("./assets/bayer_uxchart.png"),
  magritte: require("./assets/magritte.png"),
  magritte_mu: require("./assets/magritte_mu.png"),
  magritte_blender: require("./assets/magritte_blender.png"),
  magritte_clouds: require("./assets/magritte_clouds.png"),
  magritte_demo1: require("./assets/magritte_demo1.png"),
  magritte_demo2: require("./assets/magritte_demo2.png"),
  magritte_mountains: require("./assets/magritte_mountains.png"),
  magritte_painting: require("./assets/magritte_painting.png"),
  magritte_shader_ref: require("./assets/magritte_shader_ref.png"),
  magritte_shader: require("./assets/magritte_shader.png"),
  magritte_texture: require("./assets/magritte_texture.png"),
  nasa_suits: require("./assets/nasa_suits.png"),
  suits_design_nav: require("./assets/suits_design_nav.png"),
  suits_design: require("./assets/suits_design.png"),
  suits_unity: require("./assets/suits_unity.png"),
  skim: require("./assets/skim.png"),
  threedeepro: require("./assets/threedeepro.png"),
  crystal2: require("./assets/crystal2.png"),
  usd: require("./assets/usd.png"),
  usd_structure: require("./assets/usd_structure.png"),
  usd_output1: require("./assets/usd_output1.png"),
  usd_output2: require("./assets/usd_output2.png"),
  usd_output3: require("./assets/usd_output3.png"),
  usd_output4: require("./assets/usd_output4.png"),
  usd_output5: require("./assets/usd_output5.png"),
  reel: require("./assets/reel.jpg"),
  ascension: require("./assets/ascension.gif"),
  ascension_demo1: require("./assets/ascension_demo1.png"),
  ascension_asset1: require("./assets/ascension_asset1.png"),
  ascension_asset2: require("./assets/ascension_asset2.png"),
  ascension_asset3: require("./assets/ascension_asset3.png"),
  ascension_moodboard1: require("./assets/ascension_moodboard1.png"),
  ascension_moodboard2: require("./assets/ascension_moodboard2.png"),
};

export default images;
